var READY_STATE_UNINITIALIZED = 0;
var READY_STATE_LOADING = 1;
var READY_STATE_LOADED = 2;
var READY_STATE_INTERACTIVE = 3;
var READY_STATE_COMPLETE = 4;
var objAjaxRequest;
var strAjaxCallBackFunction;
var strAjaxData;
var objAjaxData;

function send_ajax_request(strCallBackFunction, strUrl, strHttpMethod, strParams, boolAsync, boolHTMLResponse)
{
    strAjaxCallBackFunction = strCallBackFunction;

    if(!strHttpMethod)
        strHttpMethod = "POST";

    if(typeof(boolAsync) === 'undefined' )
    {
        boolAsync = true;
    }
    if(typeof(boolHTMLResponse) === 'undefined' )
    {
        boolHTMLResponse = false;
    }

    objAjaxRequest = get_ajax_request_object();

    if (get_cookie('SESSION_MAIN') != '' && strUrl.indexOf("SESSION_MAIN") == -1) {
        if(strUrl.indexOf("?") > -1)
        strSep = '&';
        else
        strSep = '?';
        strUrl = strUrl+strSep+'SESSION_MAIN='+get_cookie('SESSION_MAIN');
    }

    if(objAjaxRequest)
    {

        //objAjaxRequest.onreadystatechange = process_ajax_state_change;
        objAjaxRequest.onreadystatechange = function(event) { process_ajax_state_change(boolHTMLResponse); };

        objAjaxRequest.open(strHttpMethod, strUrl, boolAsync);
        objAjaxRequest.setRequestHeader("Content-Type","application/x-www-form-urlencoded");

        objAjaxRequest.send(strParams);
    }
}

function get_ajax_request_object()
{
    var objRequest = null;
    if(window.XMLHttpRequest)
    {
        objRequest = new XMLHttpRequest(); // Mozilla / Safari
    }
    else if (typeof ActiveXObject != "undefined")
    {
        objRequest = new ActiveXObject("Microsoft.XMLHTTP"); // MSIE
    }
    try {
        objRequest.withCredentials = true;
    } catch (objException) {
        // Safari 5 and IE 10 will throw exceptions because we set
        // withCredentials before .open
    }
    return objRequest;
}

function process_ajax_state_change(boolHTMLResponse)
{
    var intState = objAjaxRequest.readyState;

    if(intState == READY_STATE_COMPLETE)
    {
        strAjaxData = objAjaxRequest.responseText;

        //alert(strAjaxData);

        if(boolHTMLResponse == true)
            eval (strAjaxCallBackFunction+"(objAjaxRequest);");
        else
        {
            objAjaxData = parse_xml_to_object(strAjaxData);
            eval (strAjaxCallBackFunction+"(objAjaxData);");
        }
        strAjaxData = null;
    }
}

function parse_xml_to_object(strAjaxData)
{
    if(is_ie()) //Internet Explorer
    {
        objXMLDoc=new ActiveXObject("Microsoft.XMLDOM");
        objXMLDoc.async="false";
        objXMLDoc.loadXML(strAjaxData);

        return objXMLDoc;
    }
    else
    {
        try //Firefox, Mozilla, Opera, etc.
        {
            objParser =new DOMParser();
            objParser.parseFromString(strAjaxData,"text/xml");

            //console.dir(objParser.parseFromString(strAjaxData,"text/xml"));

            return objParser.parseFromString(strAjaxData,"text/xml");
        }
        catch(e)
        {
            alert(e.message);
            return;
        }
    }
}
